import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBasketSummaryWrapper = styled(Box)<{isReactNativeView?: boolean}>(({isReactNativeView}) => ({
  width: '100%',
  position: 'relative',
  paddingTop: isReactNativeView ? '16px' : '24px'
}));

export const StyledUlContainer = styled('ul')<{isReactNativeView?: boolean}>(({isReactNativeView}) => ({
  width: '100%',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: isReactNativeView ? '12px' : '0'
}));

export const StyledLI = styled('li')(({theme}) => ({
  padding: theme.spacing(0, 2)
}));

export const StyledListContainer = styled(Box)<{disableBorder?: boolean}>(({theme, disableBorder}) => ({
  width: 'auto',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
  listStyle: 'none',
  justifyContent: 'space-between',
  borderBottom: !disableBorder ? `1px solid ${theme.palette.grey[200]}` : undefined
}));

export const StyledListChildrenWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(2, 0),
  listStyle: 'none'
}));

export const StyledListWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  '> .item-label': {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center'
  }
}));

export const StyledOptions = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center'
}));

export const StyledInfoButton = styled('button')(({theme}) => ({
  padding: 0,
  margin: 0,
  outline: 'none',
  border: 0,
  backgroundColor: 'transparent',
  marginLeft: theme.spacing(1),
  cursor: 'pointer'
}));

export const StyledOptionTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[300]
}));

export const StyledBox = styled(Box)(({theme}) => ({
  display: 'flex',
  width: '100%',
  backgroundColor: '#EBF9FF',
  padding: theme.spacing(1, 1),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(1)
}));

export const StyledRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const StyledBorder = styled(Box)(({theme}) => ({
  display: 'flex',
  borderBottom: `1px solid ${theme.palette.grey[200]}`
}));
